import { render } from "./ViewTemplates.vue?vue&type=template&id=7d2554ea&scoped=true"
import script from "./ViewTemplates.vue?vue&type=script&lang=js"
export * from "./ViewTemplates.vue?vue&type=script&lang=js"

import "./ViewTemplates.vue?vue&type=style&index=0&id=7d2554ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d2554ea"]])

export default __exports__